const variantMap = {
  active: 'success',
  published: 'success',
  approved: 'success',
  closed: 'default',
  inactive: 'default',
  denied: 'danger',
  raising: 'warning',
  draft: 'warning',
  suspended: 'warning',
  information_pending: 'warning',
  pending: 'info',
};

export default function Badge({ text, variant }) {
  const resolved = variant || variantMap[text?.toLowerCase()] || 'default';
  return (
    <span className={`badge badge-${resolved}`}>{text}</span>
  );
}
